import React from 'react';
import { Box, Badge, Divider, IconButton } from '@material-ui/core';
import { ExpandLess, ExpandMore, VpnKey } from '@material-ui/icons';

type PropsStatusDrawer = {
  showStatus: boolean;
  setShowStatus: any;
  list: [];
};

const StatusDrawer = ({
  showStatus,
  setShowStatus,
  list,
}: PropsStatusDrawer) => (
  <>
    {list?.length < 1 ? (
      <Box>Sin llaves</Box>
    ) : (
      <>
        <Box>
          Con llaves
          <IconButton size='medium' onClick={() => setShowStatus(!showStatus)}>
            {!showStatus ? <ExpandMore /> : <ExpandLess />}
          </IconButton>
        </Box>
        {showStatus && (
          <Box sx={{ maxHeight: '290px', overflow: 'auto' }}>
            {list.map((item: any, i) => (
              <div key={i}>
                <Divider />
                <Box
                  sx={{
                    display: 'flex',
                    mb: 1,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  Propiedad NID: <b>{item.nid}</b>
                  <IconButton disabled>
                    <Badge color='primary' badgeContent={item.total_keys}>
                      <VpnKey />
                    </Badge>
                  </IconButton>
                </Box>
              </div>
            ))}
          </Box>
        )}
      </>
    )}
  </>
);

export default StatusDrawer;
